var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumbs"},[_c('el-breadcrumb',[_vm._l((_vm.list),function(n,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(n.meta.title))])}),_vm._t("after")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }